<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <h6
      class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
    >
      {{ $t("warehouse.条件筛选") }}
    </h6>
    <div class="mg-t-10 pd-x-10 mg-b-40">
      <div class="mg-b-15 form-group">
        <input
          type="text"
          :placeholder="$t('warehouse.货架编号')"
          class="form-control form-control-dark tx-14"
          v-model.trim="keyId"
          @keyup.enter="filtrate()"
        />
      </div>
      <div class="mg-b-15 form-group">
        <input
          type="text"
          :placeholder="$t('warehouse.货架名称')"
          class="form-control form-control-dark tx-14"
          v-model.trim="keyName"
          @keyup.enter="filtrate()"
        />
      </div>
      <div class="mg-b-15 form-group">
        <input
          type="text"
          :placeholder="$t('warehouse.仓位编号')"
          class="form-control form-control-dark tx-14"
          v-model.trim="keyPosition"
          @keyup.enter="filtrate()"
        />
      </div>
      <div class="mg-b-10 form-group">
        <select
          class="form-control form-control-dark pd-y-0"
          v-model="keyStatus"
          @change="filtrate"
        >
          <option value="">{{ $t("warehouse.全部状态") }}</option>
          <option v-for="(s, k) in $dict.shelfStatus" :key="k" :value="k">
            {{ $t(s) }}
          </option>
        </select>
      </div>
      <button
        class="
          btn btn-primary btn-block
          tx-uppercase tx-11 tx-spacing-2 tx-medium
        "
        @click="filtrate"
      >
        {{ $t("warehouse.货架管理") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["status", "key_id", "key_name", "key_status", "key_position"],
  data() {
    return {
      keyId: "",
      keyName: "",
      keyStatus: "",
      keyPosition: "",
    };
  },
  watch: {
    key_id() {
      this.keyId = this.key_id;
    },
    key_name() {
      this.keyName = this.key_name;
    },
    key_status() {
      this.keyStatus = this.key_status;
    },
    key_position() {
      this.keyPosition = this.key_position;
    },
  },
  methods: {
    filtrate() {
      this.$emit(
        "filtrate",
        this.keyId,
        this.keyName,
        this.keyPosition,
        this.keyStatus
      );
    },
  },
  mounted() {
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  updated() {
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
};
</script>
